import { EventEmitter, Output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { CreateResult } from "../../../models/create-result";
import { IdTextPair } from "../../../models/id-text-pair";
import { ToastrService } from 'ngx-toastr'; 

export class validateFormHelper {

  public countries: IdTextPair[];
  public regions: IdTextPair[];
  public allRegions: IdTextPair[];
  public areas: IdTextPair[] = [];
  public selectedArea: string = '';

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  @Output() public onErrorMessage = new EventEmitter<CreateResult>();
  public SelectedCapabilitieCommsProductText: any;

  public markAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof FormGroup) {
        this.markAsTouched(control);
      }
    });
  }

  public findInvalidControls(formGroup: FormGroup) {
    const invalid = [];
    const controls = formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public formValidation(formGroup: FormGroup, message: CreateResult): CreateResult {
    this.markAsTouched(formGroup);
    if (formGroup.invalid) {
      this.onErrorMessage.emit(message);
      return message
    }
    else {
      message.message = "success";
      message.success = true;
      this.onErrorMessage.emit(message);
      return message
    }
  }

  public showError(message: CreateResult): CreateResult {
    this.onErrorMessage.emit(message);
    return message
  }

  public showStaticAndPopupError(message: CreateResult, toastService: ToastrService): CreateResult {
   
    toastService?.error(message.message, 'Error');
    this.onErrorMessage.emit(message);
    return message
  }

  async hasValideResponse(message: CreateResult): Promise<CreateResult> {
    var response = await (await message);
    this.onErrorMessage.emit(response);
    return response;
  }

  public async isValidation(message: CreateResult): Promise<CreateResult> {

    if (message.success) {
      this.onErrorMessage.emit(message);
      return message
    }
    else {
      message.message = "success";
      message.success = true;
      this.onErrorMessage.emit(message);
      return message
    }
  }
}




